import {
  PortableTextHtmlComponents,
  PortableTextComponentOptions,
  uriLooksSafe
} from '@portabletext/to-html';
import { ImageWithMeta, Reference } from './sanity.types';
import { DomSanitizer } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';

export const contentBlockComponents = (
  sanitizer: DomSanitizer,
  largeScreen: boolean
): Partial<PortableTextHtmlComponents> => ({
  types: {
    image: ({ value }: { value: ImageWithMeta }) =>
      `<img src="${value.src}" srcset=${value.srcset} alt="${value.alt}" class="sanity-image" />`,
    youtube: ({ value }: { value: { url: string } }) => {
      const videoId = value.url.includes('v=')
        ? value.url.split('v=')[1]
        : value.url.split('be/')[1];
      return `<div class="sanity-youtube"><iframe ${
        largeScreen ? 'width="560" height="315"' : ''
      } src="https://www.youtube-nocookie.com/embed/${videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
    },
    productReference: ({ value }: { value: Reference }) =>
      `<span><a href="/privat/nettbutikk/${
        value.slug?.toLowerCase() ?? value.id
      }">${value.title}</a></span>`,
    articleReference: ({ value }: { value: Reference }) =>
      `<span><a href="/om/aktuelt/${value.slug?.toLowerCase() ?? value.id}">${
        value.title
      }</a></span>`,
    fileReference: ({ value }: { value: { url: string; title: string } }) =>
      `<span><a href="${value.url}">${value.title}</a></span>`
  },
  marks: {
    highLight: ({ children }: { children: string }) =>
      `<span class="sanity-highlight">${children}</span>`,
    link: ({ children, value }) => {
      const href = uriLooksSafe(value.href) ? value.href : '';
      if (value?.style === 'button' || value?.style === 'button-primary') {
        return `<a href="${href}" class="sanity-${value.style}" ${
          value.blank ? 'target="_blank"' : ''
        }>${children} ${
          value?.arrow
            ? '<ion-icon slot="end" name="arrow-forward-outline"></ion-icon>'
            : ''
        }</a>`;
      }
      return `<a href="${href}" ${
        value.blank ? 'target="_blank"' : ''
      }>${children}</a>`;
    }
  },
  list: {
    check: (value: PortableTextComponentOptions<any>) => {
      return `<ul class="list-checkmarks">${value.children}</ul>`;
    }
  },
  unknownBlockStyle: (value: PortableTextComponentOptions<any>) => {
    return sanitizer.sanitize(SecurityContext.HTML, value.children);
  },
  unknownListItem: (value: PortableTextComponentOptions<any>) => {
    return sanitizer.sanitize(SecurityContext.HTML, value.children);
  }
});
